import { render, staticRenderFns } from "./PageNurse.vue?vue&type=template&id=fba8ca8a&scoped=true&"
import script from "./PageNurse.vue?vue&type=script&lang=js&"
export * from "./PageNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba8ca8a",
  null
  
)

export default component.exports